import { FeatureLink } from "@softmax/web-features/navigation";

import { getStartedLink } from "@softmax/web-features/site/records";

import { isNavigationClick } from "./link-click";
import styles from "./account-pill.module.css";

import type { PillViewer } from "./pill-viewer";
import type { PillMenuData } from "./use-pill-menu";
import type { SiteHeaderControls } from "./use-site-header";

export function SiteHeaderActions({
  viewer,
  agent,
  disclosure,
  onNavigate,
}: {
  readonly viewer: PillViewer | null;
  readonly agent: PillMenuData["agent"];
  readonly disclosure: SiteHeaderControls["disclosure"];
  readonly onNavigate: SiteHeaderControls["onNavigate"];
}) {
  const initial = viewer?.name.trim().charAt(0).toUpperCase() ?? "";
  const agentInitial = agent?.name.trim().charAt(0).toUpperCase() ?? "";

  return (
    <div className={styles.end}>
      <button
        className={`${styles.link} ${styles.searchIcon}`}
        aria-label="Search"
        title="Search"
        data-cogent-safe
        {...disclosure("search")}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path
            d="m20 20-3.8-3.8"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
      {viewer ? (
        <button
          className={`${styles.link} ${styles.avatars}`}
          aria-label="Account menu"
          title={viewer.name}
          {...disclosure("account")}
        >
          <span className={styles.pair} aria-hidden="true">
            <span className={`${styles.circle} ${styles.user}`}>
              {viewer.image ? <img src={viewer.image} alt="" /> : initial}
            </span>
            {(agent?.avatar_url || agentInitial) && (
              <span className={`${styles.circle} ${styles.back}`}>
                {agent?.avatar_url ? (
                  <img src={agent.avatar_url} alt="" />
                ) : (
                  agentInitial
                )}
              </span>
            )}
          </span>
        </button>
      ) : (
        <FeatureLink
          href={getStartedLink.href}
          className={styles.action}
          onClick={(event) => {
            if (isNavigationClick(event)) onNavigate(getStartedLink.href);
          }}
        >
          {getStartedLink.label}
        </FeatureLink>
      )}
    </div>
  );
}
